

//window._webWorker = null;

//window.markdownToHtml = (markdown) => {
//    const converter = new showdown.Converter();
//    return converter.makeHtml(markdown);
//};

//window.initWebWorker = (handler, method) => {
//    this.stopWebWorker();

//    console.log("Initializing WebWorker.");
//    this._webWorker = new Worker(new URL("./authWorker.js", import.meta.url));

//    this._webWorker.onmessage = (msg) => {
//        handler.invokeMethodAsync(method, msg.data);
//        const accessToken = localStorage.getItem("accessToken");
//        if (accessToken) {
//            try {
//                handler.invokeMethodAsync(method, msg.data);
//            } catch (e) {
//                console.warn("Failed to call WebWorker callback: " + e);
//            }
//        }
//    };
//};

//window.stopWebWorker = () => {
//    if (this._webWorker) {
//        console.log("Stopping WebWorker.");
//        this._webWorker.terminate();
//        this._webWorker = null;
//    }
//};


//window.getElementAttribute = (el, attrName, handler, method) => {
//    handler.invokeMethodAsync(method, el[attrName]);
//};

//window.setElementAttribute = (el, attrName, value) => {
//    el.setAttribute(attrName, value);
//};

//window.callMethodOnObject = (el, func, ...args) => {
//    el[func](...args);
//};

//window.callFunc = (func, ...args) => {
//    if (window.visitformgxJs[func]) {
//        try {
//            return window.visitformgxJs[func](...args);
//        } catch (e) {
//            console.warn(e);
//        }
//    } else {
//        console.error("interop func not defined: " + func);
//    }
//};
